import PropTypes from 'prop-types';

export default PropTypes.exact({
	field: PropTypes.string,
	message: PropTypes.string,
	code: PropTypes.string
});
